import { Box } from '@mui/material';
import { ControlledBubbleMenu, MenuControlsContainer, useRichTextEditorContext } from 'mui-tiptap';
import React, { FC } from 'react';
import { AddStandardLinkToolbarButton } from './toolbar/AddStandardLinkToolbarButton';
import { AddGuideLinkToolbarButton } from './toolbar/AddGuideLinkToolbarButton';
import { AddCitationLinkToolbarButton } from './toolbar/AddCitationLinkToolbarButton';
import { AddInternalLinkToolbarButton } from './toolbar/AddInternalLinkToolbarButton';
import { theme } from '../../../../theme';
import { AddCommentToolbarButton } from './toolbar/AddCommentToolbarButton';
import { useFeatureFlags } from '../../../../unleash';
import { LookUpInDictionaryToolbarButton } from './toolbar/LookUpInDictionaryToolbarButton';

export const TextBubbleMenu: FC<{ guideId: string }> = ({ guideId }) => {
  const editor = useRichTextEditorContext();
  const { cmsComments, dictionary } = useFeatureFlags();

  if (!editor?.isEditable || !editor?.isInitialized) {
    return null;
  }
  const isOpen =
    !editor.view.state.selection.empty &&
    !editor.isActive('link') &&
    !editor.isActive('internalLink') &&
    !editor.isActive('attachment') &&
    !editor.isActive('pageBreak');
  return (
    <ControlledBubbleMenu editor={editor} open={isOpen} sx={{ zIndex: '1000 !important' }}>
      <Box sx={{ padding: theme.spacing(0.5, 1) }}>
        <MenuControlsContainer>
          <AddStandardLinkToolbarButton />
          <AddGuideLinkToolbarButton guideId={guideId} />
          <AddCitationLinkToolbarButton />
          <AddInternalLinkToolbarButton />
          {cmsComments && <AddCommentToolbarButton />}
          {dictionary && <LookUpInDictionaryToolbarButton />}
        </MenuControlsContainer>
      </Box>
    </ControlledBubbleMenu>
  );
};
